import { styled, Typography } from "@mui/material";
import colors from "styles/colors";

const DimmedTypoGraphy = styled(Typography)(() => ({
    color: colors.dimmedText,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
}));
export default DimmedTypoGraphy;